// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { useState, useEffect } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";

import { ConfirmDialog, DataTable, FilterBar, StatusBadge } from "components/shared";
import EditPaymentAccountModal from "./payments/EditPaymentAcountModal";
import CreatePaymentAccountModal from "./payments/CreatePaymentAccountModal";
//data
import {
  PAYMENT_ACCOUNT_API,
  DELETE_PAYMENT_ACCOUNT_API,
  UPDATE_PAYMENT_ACCOUNT_API,
  CREATE_PAYMENT_ACCOUNT_API,
} from "../../services/CONSTANTS";
import {
  getApiDataService,
  deleteApiDataService,
  putApiDataService,
  postApiDataService,
} from "../../services/apiServices";

const COLUMNS = [
  { key: "index", label: "#" },
  { key: "provider", label: "Provider" },
  { key: "accountName", label: "AccountName" },
  { key: "accountNo", label: "Account No" },
  { key: "status", label: "Status" },
  { key: "for", label: "For" },
  { key: "actions", label: "" },
];

const PaymentAccountList = () => {
  const history = useHistory();
  const [paymentAccounts, setpaymentAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [item, setitem] = useState(null);

  useEffect(() => {
    fetchPaymentAccounts();
  }, []);

  const handleCreateClick = () => {
    console.log("Create item");
    setShowCreateModal(true);
  };

  const handleDeleteClick = (item) => {
    console.log("Delete item", item);
    setitem(item);
    setShowDeleteModal(true);
  };

  const handleEditClick = (item) => {
    console.log("Edit item", item);
    setitem(item);
    setShowEditModal(true);
  };

  const fetchPaymentAccounts = () => {
    setIsLoading(true);
    getApiDataService(PAYMENT_ACCOUNT_API)
      .then((res) => {
        setpaymentAccounts(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setpaymentAccounts([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  const handleDeleteConfirm = () => {
    setIsLoading(true);
    console.log("Deleting item", item.id);
    deleteApiDataService(DELETE_PAYMENT_ACCOUNT_API(item.id))
      .then((res) => {
        console.log("Delete success", res);
        setShowDeleteModal(false);
        fetchPaymentAccounts();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in delete!", err);
      });
  };

  const handleModalBoxCancel = () => {
    setShowDeleteModal(false);
    setShowEditModal(false);
    setShowCreateModal(false);
  };

  const handleUpdateSubmit = (data) => {
    console.log("data", data);
    setIsLoading(true);
    putApiDataService(UPDATE_PAYMENT_ACCOUNT_API(item?.id), data)
      .then((res) => {
        console.log(res);
        setIsLoading(false);
        setShowEditModal(false);
        fetchPaymentAccounts();
      })
      .catch((err) => {
        console.log("Error in handleUpdateSubmit!", err);
      });
  };

  const handleCreateSubmit = (data) => {
    console.log("data", data);
    setIsLoading(true);
    postApiDataService(CREATE_PAYMENT_ACCOUNT_API, data)
      .then((res) => {
        console.log(res);
        setIsLoading(false);
        setShowCreateModal(false);
        fetchPaymentAccounts();
      })
      .catch((err) => {
        console.log("Error in handleCreateSubmit!", err);
      });
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar title="Payment Account List">
                  <button
                    onClick={() => handleCreateClick()}
                    className="btn btn-sm btn-primary"
                  >
                    Create
                  </button>
                </FilterBar>
              </CardHeader>
              <DataTable
                className="table-striped"
                columns={COLUMNS}
                data={paymentAccounts}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(payment_account, index) => (
                  <tr key={payment_account?.id ?? index}>
                    <th>{index + 1}</th>
                    <th scope="row">
                      <Media className="align-items-center">
                        <a
                          className="avatar rounded-circle mr-3"
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        >
                          <img
                            alt="..."
                            src={payment_account?.payment_provider?.logo}
                            style={{ width: "60px" }}
                          />
                        </a>
                        <Media>
                          <span className="mb-0 text-sm">
                            {payment_account?.payment_provider?.name}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td>{payment_account?.account_name}</td>
                    <td className="font-mono">{payment_account?.account_no}</td>
                    <td>
                      <StatusBadge status={payment_account?.status} />
                    </td>
                    <td>
                      <Badge color="primary" pill>
                        {payment_account?.types.toString()}
                      </Badge>
                    </td>
                    <td className="text-right">
                      <div className="row">
                        <div className="col">
                          <button
                            className="btn btn-outline-success btn-sm"
                            onClick={() => handleEditClick(payment_account)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(payment_account)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              />
            </Card>
          </div>
        </Row>
      </Container>
      {showDeleteModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Delete"
          message="Are you sure you want to delete this item?"
          confirmText="Yes"
          confirmColor="danger"
          isLoading={isLoading}
          onConfirm={handleDeleteConfirm}
        />
      )}
      {showEditModal && (
        <EditPaymentAccountModal
          item={item}
          onClose={handleModalBoxCancel}
          onSubmit={handleUpdateSubmit}
        />
      )}
      {showCreateModal && (
        <CreatePaymentAccountModal
          onClose={handleModalBoxCancel}
          onSubmit={handleCreateSubmit}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default PaymentAccountList;
